import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../environment";

const LoanSummary = () => {

    const [data, setData] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const fetchSummary = async () => {
        try {
            const userInfo = JSON.parse(sessionStorage.getItem("info") || "{}");

            if (!userInfo.user_id) {
                console.error("User ID is missing from the current session");
                return;
            }

            const res = await axios.get(`${API_BASE_URL}/filter/company_statement`, {
                params: {
                    fromDate,
                    toDate,
                    user_id: userInfo.user_id,
                    financer_id: userInfo.id,
                    user_type: userInfo.type
                }
            });
            setData(res.data.summary);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchSummary();
    }, []);

    const downloadCSV = () => {
        if (!data) return;

        const summaryData = [
            { title: "Total Disbursement", value: data.totalDisbursement },
            { title: "Total Principal", value: data.totalPrincipal },
            { title: "Principal Received", value: data.totalPrincipalPaid },
            {
                title: "Total Balance Principal",
                value: data.balancePrincipal,
            },
            { title: "File Charges", value: data.totalFileCharge },
            { title: "Other Charges", value: data.totalOtherCharges },
            { title: "Total EMI Amount", value: data.totalEmiAmount },
            { title: "Total Due EMI Amount", value: data.totalPendingEmi },
            { title: "Total Interest", value: data.totalInterest },
            {
                title: "Total Interest Received",
                value: data.totalReceivedInterest,
            },
            {
                title: "Total Interest Pending",
                value: Number(data.totalInterest) - data.totalReceivedInterest,
            },
            { title: "Total Payment Received", value: data.totalPaid },
            { title: "Total Discount", value: data.totalDiscount },
            { title: "Total Penalty", value: data.totalPenalty },
        ];

        // Convert to CSV
        const headers = ["Title", "Amount"];
        const rows = summaryData.map(item => [item.title, item.value]);

        let csvContent =
            headers.join(",") +
            "\n" +
            rows.map(e => e.join(",")).join("\n");

        // Create Blob and Download
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "loan_summary.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="page-wrapper">
            <div className="content">

                <h2 className="mb-4">Loan Dashboard</h2>

                {/* Date Filters */}
                <div className="row mb-4">

                    <div className="col-md-3">
                        <input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>

                    <div className="col-md-3">
                        <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>

                    <div className="col-md-2">
                        <button
                            className="btn btn-primary w-100"
                            onClick={fetchSummary}
                        >
                            Filter
                        </button>
                    </div>
                    <div className="col-md-2">
                        <button
                            className="btn btn-success w-100"
                            onClick={downloadCSV}
                        >
                            Download CSV
                        </button>
                    </div>

                </div>

                {/* Dashboard Cards */}

                {data && (

                    <div className="row g-4">

                        <Card title="Total Disbursement" value={Number(data.totalDisbursement)} />
                        <Card title="Total Principal" value={Number(data.totalPrincipal)} />
                        <Card title="Principal Received" value={data.totalPrincipalPaid} />
                        <Card title="Total Balance Principal" value={data.balancePrincipal} />
                        <Card title="File Charges" value={data.totalFileCharge} />
                        <Card title="Other Charges" value={data.totalOtherCharges} />
                        <Card title="Total EMI Amount" value={data.totalEmiAmount} />
                        <Card title="Total Due EMI Amount" value={data.totalPendingEmi} />
                        <Card title="Total Interest" value={data.totalInterest} />
                        <Card title="Total Interest Received" value={data.totalReceivedInterest} />
                        <Card title="Total Interest Pending" value={Number(data.totalInterest) - data.totalReceivedInterest} />
                        <Card title="Total Payment Received" value={data.totalPaid} />
                        <Card title="Total Discount" value={data.totalDiscount} />
                        <Card title="Total Penalty" value={data.totalPenalty} />
                    </div>

                )}

            </div>
        </div>
    );
};

const Card = ({ title, value }) => {

    return (
        <div className="col-md-4">
            <div className="card shadow-sm border-0">
                <div className="card-body text-center">
                    <h6 className="text-muted">{title}</h6>
                    <h3 className="fw-bold">₹ {(Number(value) || 0).toFixed(2)}</h3>
                </div>
            </div>
        </div>
    );
};

export default LoanSummary;
